<template>
  <div v-loading="loading" class="vg_wrapper">
    <el-card>
      <div v-if="activeTab !== '出错纠错统计'" class="button-container vg_mb_5">
        <button
          v-for="(btn, index) in buttons.slice(0, -2)"
          :key="index"
          :class="['jobsBorder', 'el-button', 'el-button--default', { 'active-button': module === btn }]"
          @click="changeModule(btn)"
        >
          {{ btn === '备料' ? btn + '(出库)' : btn }}
        </button>
        <div class="jobsBorder grouped-buttons">
          <button
            v-for="btn in buttons.slice(-2)"
            :key="btn"
            :class="['el-button', 'el-button--default', 'grouped-btn', { 'active-button': module === btn }]"
            @click="changeModule(btn)"
          >
            {{ btn }}
          </button>
        </div>
      </div>
      <div v-else class="button-container2 vg_mb_5">
        <button
          v-for="(btn, index) in buttons2"
          :key="index"
          :class="['jobsBorder', 'el-button', 'el-button--default', { 'active-button': module2 === btn }]"
          @click="changeModule(btn)"
        >
          {{ btn }}
        </button>
      </div>
      <el-tabs v-model="activeTab" type="border-card" @tab-click="val => changeModule(activeTab !== '出错纠错统计' ? module : module2)">
        <el-tab-pane label="工作量统计" name="工作量统计">
          <el-row>
            <el-col :span="24" style="margin-bottom: 20px; margin-top: 10px">
              <div class="diagramTitle">
                <span style="font-size: 20px; margin-right: 10px">统计时间:</span>
                <div class="dateSelect">
                  <el-date-picker v-model="daytime[0]" type="date"> </el-date-picker>
                  <span style="font-size: 20px">至</span>
                  <el-date-picker v-model="daytime[1]" type="date"> </el-date-picker>
                </div>
                <el-button class="buttonText" round size="mini" @click="timeScope(1)">近一月</el-button>
                <el-button class="buttonText" round size="mini" @click="timeScope(3)">近三月</el-button>
                <el-button class="buttonText" round size="mini" @click="timeScope(6)">近六月</el-button>
                <el-button class="buttonText" round size="mini" @click="timeScope(0)">全部</el-button>
                <el-button class="buttonText" round size="mini" type="primary" @click="getTableData()">查询</el-button>
                <el-button class="buttonText" round size="mini" type="info" @click="refresh">刷新</el-button>
                <!-- <el-button class="buttonText" round size="mini" type="success" @click="exportToExcel">导出Excel</el-button> -->
                <!--<el-button v-if="module === '手工'" class="buttonText" round size="mini" type="warning" @click="dialogVisible = true"-->
                <!--  >难度系数调整-->
                <!--</el-button>-->
              </div>
            </el-col>
            <el-col :span="24">
              <open
                v-show="module === '开版'"
                ref="开版"
                :daytime="daytime"
                :module="module"
                :tableData="tableData"
                @getTableData="getTableData"
              ></open>
              <typesetting
                v-show="module === '排版'"
                ref="排版"
                :daytime="daytime"
                :module="module"
                :tableData="tableData"
                @getTableData="getTableData"
              ></typesetting>
              <stap
                v-show="module === '印花'"
                ref="印花"
                :daytime="daytime"
                :module="module"
                :tableData="tableData"
                @getTableData="getTableData"
              ></stap>
              <emcd
                v-show="module === '制卡'"
                ref="制卡"
                :daytime="daytime"
                :module="module"
                :tableData="tableData"
                @getTableData="getTableData"
              ></emcd>
              <lase
                v-show="module === '激光'"
                ref="激光"
                :daytime="daytime"
                :module="module"
                :tableData="tableData"
                @getTableData="getTableData"
              ></lase>
              <embr
                v-show="module === '电绣'"
                ref="电绣"
                :daytime="daytime"
                :module="module"
                :tableData="tableData"
                @getTableData="getTableData"
              ></embr>
              <HandCut
                v-show="module === '手裁'"
                ref="手裁"
                :daytime="daytime"
                :module="module"
                :tableData="tableData"
                @getTableData="getTableData"
              ></HandCut>
              <stpr v-show="module === '备料'" ref="备料" :tableData="tableData" @getTableData="getTableData"></stpr>
              <comp
                v-show="module === '复合'"
                ref="复合"
                :daytime="daytime"
                :module="module"
                :tableData="tableData"
                @getTableData="getTableData"
              ></comp>
              <mase
                v-show="module === '机缝'"
                ref="机缝"
                :daytime="daytime"
                :module="module"
                :tableData="tableData"
                @getTableData="getTableData"
              ></mase>
              <manu
                v-show="module === '手工'"
                ref="手工"
                :daytime="daytime"
                :module="module"
                :tableData="tableData"
                @getTableData="getTableData"
              ></manu>
              <insp v-show="module === '检验'" ref="检验" :tableData="tableData" @getTableData="getTableData"></insp>
              <inbound v-show="module === '入库'" ref="入库" :tableData="tableData" @getTableData="getTableData"></inbound>
              <quotation v-show="module === '报价'" ref="报价" :tableData="tableData" @getTableData="getTableData"></quotation>
              <dataEntry v-show="module === '数据录入'" ref="数据录入" :tableData="tableData" @getTableData="getTableData"></dataEntry>
            </el-col>
          </el-row>
        </el-tab-pane>
        <!-- <el-tab-pane label="出错纠错统计" name="出错纠错统计">
          <CorrectionStatistics ref="correctionStatisticsRef" :module="module2"></CorrectionStatistics>
        </el-tab-pane>
        <el-tab-pane label="工作绩效统计" name="工作绩效统计">
          <PerformanceStatistics ref="performanceStatisticsRef" :module="module"></PerformanceStatistics>
        </el-tab-pane> -->
      </el-tabs>
    </el-card>
    <el-dialog :visible.sync="dialogVisible" title="难度系数调整" top="0" width="50%">
      <search-table
        ref="searchTable"
        :columnMove="false"
        :columns="dialogTableProperties"
        :data="dialogTableData"
        :fixedHeightParam="400"
        :need-fixed-height="false"
        :need-pagination="false"
        :need-search="false"
        :tableRowKey="'id'"
      />
      <div class="vg_mt_8" style="display: flex">
        <el-button class="buttonText" round size="mini" style="margin-left: auto" type="danger" @click="editDiffListData">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get, getNoCatch, postNoCatch } from '@api/request';
import { dataStaticsAPI } from '@api/modules/stat';
import Open from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Open';
import Typesetting from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Typesetting';
import Stap from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Stap';
import HandCut from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/HandCut';
import Stpr from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Stpr';
import Lase from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Lase';
import Comp from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Comp';
import Embr from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Embr';
import Emcd from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Emcd';
import Mase from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Mase';
import Manu from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Manu';
import Insp from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Insp.vue';
import Inbound from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Inbound.vue';
import Quotation from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/Quotation.vue';
import DataEntry from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/DataEntry.vue';
import CorrectionStatistics from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/CorrectionStatistics.vue';
import PerformanceStatistics from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/PerformanceStatistics.vue';
import { cloneDeep } from 'lodash';
import SearchTable from '@/components/SearchTableV3.vue';
import { keep1Decimal, keepNumber } from '@assets/js/regExUtil';
import {
  buttons,
  buttons2,
  dialogProperties,
  eChatsOptions1,
  eChatsOptions2
} from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/pvys';

export default {
  name: 'ProductValueYieldStatistics',
  components: {
    SearchTable,
    Open,
    Typesetting,
    Stap,
    Emcd,
    Lase,
    Embr,
    HandCut,
    Stpr,
    Comp,
    Mase,
    Manu,
    Insp,
    Inbound,
    Quotation,
    DataEntry,
    CorrectionStatistics,
    PerformanceStatistics
  },
  data() {
    return {
      allTableData: [],
      currentPage: 1,
      loading: false,
      daytime: '',
      option: eChatsOptions1,
      option2: eChatsOptions2,
      tableData: [],
      totalPage: 0,
      startTime: '',
      endTime: '',
      module: '开版',
      module2: '开版师',
      dialogVisible: false,
      dialogTableData: [],
      dialogTableProperties: dialogProperties,
      buttons: buttons,
      buttons2: buttons2,
      activeTab: '工作量统计'
    };
  },
  mounted() {
    this.timeScope(1);
  },
  methods: {
    keep1Decimal,
    keepNumber,
    // 导出excel
    exportToExcel() {
      getNoCatch(dataStaticsAPI.excelProcessStatistics, this.getSearchForm()).then(({ data }) => {
        this.helper.downloadItemExcel(data.url, data.fileName);
      });
    },
    getTableData() {
      this.getData();
    },
    // 模块选择变动加载
    changeModule(module) {
      switch (this.activeTab) {
        case '工作量统计':
          this.module = module;
          this.getTableData();
          break;
        case '出错纠错统计':
          this.module2 = module;
          this.$nextTick(() => {
            this.$refs.correctionStatisticsRef.getTableData();
          });
          break;
        case '工作绩效统计':
          this.module = module;
          this.$nextTick(() => {
            this.$refs.performanceStatisticsRef.getTableData();
          });
          break;
      }
    },
    refresh() {
      const ref = this.$refs[this.module];
      if (ref.resetFields) {
        ref.resetFields();
      } else if (ref.$refs?.searchTable) {
        ref.$refs.searchTable.resetFields();
      }
      this.daytime = [];
      this.startTime = null;
      this.endTime = null;
      this.getData();
    },
    getSearchForm() {
      const ref = this.$refs[this.module];
      let searchForm;
      if (ref.getSearchForm) {
        searchForm = cloneDeep(ref.getSearchForm());
      } else if (ref.$refs?.searchTable) {
        searchForm = cloneDeep(ref.$refs.searchTable.searchForm);
      }
      searchForm = searchForm || {};
      searchForm.module = this.activeTab !== '出错纠错统计' ? this.module : this.module2;
      searchForm.stff_name = searchForm?.stff_name || null;
      searchForm.column = searchForm?.column || null;
      searchForm.order = searchForm?.order || null;
      searchForm.dept_name = this.$cookies.get('userInfo').dept_name;
      searchForm.type = 1;
      searchForm.isExport = false;
      const [startTime, endTime] = cloneDeep(this.daytime || []);
      // 确保时间戳被正确赋值且进行单位转换（如果需要）
      searchForm.start_time = startTime ? Math.floor(startTime / 1000) : null;
      let secondDate = new Date(endTime);
      secondDate.setHours(23, 59, 59, 999);
      searchForm.end_time = endTime ? Math.floor(secondDate.getTime() / 1000) : null;
      searchForm.stff_name = searchForm.employee_name;
      return searchForm;
    },
    getData() {
      this.loading = true;
      get(dataStaticsAPI.processStatisticsyz, this.getSearchForm()).then(({ data }) => {
        if (data.code === 0) {
          this.tableData = data.data.list;
          this.loading = false;
        }
      });
      if (this.module === '手工') {
        this.getDiffListData();
      }
    },
    timeScope(val) {
      let firstDate = new Date();
      firstDate.setMonth(firstDate.getMonth() - val);
      firstDate.setDate(26);
      firstDate.setHours(0, 0, 0, 0);
      let secondDate = new Date();
      secondDate.setDate(25);
      secondDate.setHours(23, 59, 59, 999);
      this.daytime = val === 0 ? [] : [Math.floor(firstDate.getTime()), Math.floor(secondDate.getTime())];
      this.getData();
    },
    getDiffListData() {
      getNoCatch(dataStaticsAPI.getDiffList).then(({ data }) => {
        this.dialogTableData = data;
      });
    },
    editDiffListData: function () {
      postNoCatch(dataStaticsAPI.editDiffList, this.dialogTableData).then(({ data }) => {
        this.dialogVisible = false;
        this.getData();
        this.$message.success('操作成功!');
      });
    }
  }
};
</script>

<style scoped>
.button-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  padding: 0;
}
.button-container2 {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
  padding: 0;
}
.jobsBorder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
  font-size: 18px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  margin-left: 0 !important;
}

.grouped-buttons {
  padding: 0;
  overflow: hidden;
  border-radius: 4px;
}

.grouped-btn {
  flex: 1;
  height: 100%;
  font-size: 18px;
  margin: 0 !important;
  border-radius: 0;
  border-width: 0;
  box-shadow: none !important;
}

.grouped-btn + .grouped-btn {
  border-left-width: 1px !important;
  border-left-style: solid !important;
  border-left-color: #dcdfe6 !important;
}

.grouped-btn:hover {
  background-color: #ecf5ff;
}

.grouped-btn.active-button {
  border-left-color: #409eff !important;
}

.active-button {
  background-color: #409eff !important;
  color: white !important;
  border-color: #409eff !important;
}

.jobsBorder2 {
  display: inline-block;
  justify-content: center;
  align-items: center;
  height: 70px;
  width: 45%;
  font-size: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.diagramTitle {
  display: flex;
  align-items: center;
}

.dateSelect {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.buttonText {
  font-size: 18px;
}
</style>
